<h1 mat-dialog-title *ngIf="!data?.item?.email">{{'admin.accounts.addNew' | translate}}</h1>
<h1 mat-dialog-title *ngIf="data?.item?.email">{{'admin.accounts.edit' | translate}}</h1>

<div>
    <form [formGroup]="form">
        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 250px;">
            <mat-label>{{"admin.accounts.email" | translate }}<span class="span-label-required"></span></mat-label>
            <input matInput placeholder='{{"admin.accounts.email" | translate }}' formControlName="email">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('email').errors?.required && (form.get('email').touched || (form.get('email').dirty)))">
            {{"common.validation.accountsSuperAdmin.emailRequired" | translate}}
        </span>
        <span style="color: red;" *ngIf="(form.get('email').errors?.email && (form.get('email').touched || (form.get('email').dirty)))">
            {{"common.validation.email" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 250px;">
            <mat-label>{{"admin.accounts.customerName" | translate }}<span class="span-label-required"></span></mat-label>
            <input matInput placeholder='{{"admin.accounts.customerName" | translate }}' formControlName="customerName">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('customerName').errors?.required && (form.get('customerName').touched || (form.get('customerName').dirty)))">
            {{"common.validation.accountsSuperAdmin.customerNameRequired" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 250px;">
            <mat-label>{{"admin.accounts.customerNumber" | translate }}<span class="span-label-required"></span></mat-label>
            <input matInput placeholder='{{"admin.accounts.customerNumber" | translate }}' formControlName="customerNumber">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('customerNumber').errors?.required && (form.get('customerNumber').touched || (form.get('customerNumber').dirty)))">
            {{"common.validation.accountsSuperAdmin.customerNumberRequired" | translate}}
        </span>
        <span style="color: red;" *ngIf="(form.get('customerNumber').errors?.customerNumberExists && (form.get('customerNumber').touched || (form.get('customerNumber').dirty)))">
            {{"common.validation.account.customerNumberExists" | translate}}
        </span>

    </form>

    <div class="d-flex" style="margin-top: 20px;">
        <label>{{"admin.accounts.active" | translate}}<span class="span-label-required"></span></label>
        <mat-checkbox class="checkbox" [(ngModel)]="isActive"></mat-checkbox>
    </div>

    <div class="d-flex" style="margin-top: 20px;">
        <button mat-flat-button color="primary" class="action-button" (click)="save()">{{'common.buttons.save' | translate}}</button>
        <button mat-flat-button color="primary" class="action-button" (click)="discard()">{{'common.buttons.cancel' | translate}}</button>
    </div>
</div>
